export enum ReportType {
  PHARMACY_INVOICE_NCPDP = 'Pharmacy Invoice NCPDP',
  PHARMACY_INVOICE_NCPDP_PN = 'Pharmacy Invoice NCPDP with PN',
  PHARMACY_INVOICE_NDC_SUMMARY = 'Pharmacy Invoice NDC Summary',
  PHARMACY_INVOICE_PLAN_NDC_SUMMARY = 'Pharmacy Invoice Plan NDC Summary',
  PHARMACY_MARKET_BASKET_NCPDP = 'Pharmacy Market Basket NCPDP',
  PHARMACY_MARKET_BASKET_NCPDP_PN = 'Pharmacy Market Basket NCPDP with PN',
  PHARMACY_MARKET_BASKET_NCPDP_PN_ONLY = 'Pharmacy Market Basket NCPDP PN Only',
  PHARMACY_MARKET_BASKET_SHARE = 'Pharmacy Market Basket Share',
  MEDICAL_INVOICE_NCPDP = 'Medical Invoice NCPDP',
  MEDICAL_INVOICE_NCPDP_PN = 'Medical Invoice NCPDP with PN',
  MEDICAL_INVOICE_NDC_SUMMARY = 'Medical Invoice NDC Summary',
  MEDICAL_INVOICE_PLAN_NDC_SUMMARY = 'Medical Invoice Plan NDC Summary',
  MEDICAL_MARKET_BASKET_NCPDP = 'Medical Market Basket NCPDP',
  MEDICAL_MARKET_BASKET_NCPDP_PN = 'Medical Market Basket NCPDP with PN',
  MEDICAL_MARKET_BASKET_NCPDP_PN_ONLY = 'Medical Market Basket NCPDP PN Only',
  MEDICAL_MARKET_BASKET_SHARE = 'Medical Market Basket Share',
  INVOICE_SUMMARY = 'Invoice Summary',
  INVOICE_PLAN_SUMMARY = 'Invoice Plan Summary',
  INVOICE_PLAN_DRUG_SUMMARY = 'Invoice Plan Drug Summary',
  EXCLUSION_REPORT = 'Exclusion Report',
  CLAIM_DATA_LOAD_SUMMARY = 'Claim Data Load Summary'
}
